export function Flag(key, data) {
  return {
    key,
    variation: data.variation,
    abTest: data.abTest,
  };
}
